import React from 'react';
import { Link } from 'react-router-dom';

class NavigationBar extends React.Component {
    render() {
      return (
            <div className="mb-4">
                <nav className="navbar navbar-expand-lg navbar-light bg-light">
                    <img src="/static/pzbs_logo.png" height="50" className="mr-3" />
                    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
                        <div className="navbar-nav">
                            <Link className="nav-item nav-link active" to="/">Turnieje</Link>
                        </div>
                    </div>
                    <div>
                        <div className="navbar-nav">
                            { window.localStorage.getItem("loggedAsAdmin") ?
                                <Link className="nav-item nav-link active" to="/login">Zaloguj się</Link>
                                : ''
                            }
                        </div>
                    </div>
                </nav>
            </div>
        );
    }
  }

export default NavigationBar;



// WEBPACK FOOTER //
// ./components/NavigationBar.js